export default "__VITE_ASSET__ofDH1m4p__"